import Tr from 'translations/Translations'

export const Directions = {
    ASCENDING: 'ASCENDING',
    DESCENDING: 'DESCENDING',
}

export const PriceDirections = {
    ...Directions,
    DESCENDING_BY_PRICE_ITEMS: 'DESCENDING_BY_PRICE_ITEMS'
}

const createItem = (key) => ({
    label: Tr(`direction.${key}`),
    value: key,
})

export const CriterionDictionaryItems = Object.keys(Directions).map(key => createItem(key));
export const PriceCriterionDictionaryItems = Object.keys(PriceDirections).map(key => createItem(key));
